export const name = "STRING (JSON)";
export const summary = `Converts a JSON string to a SQL \`STRING\` value.`;
export const reference = `
## STRING (JSON)

Converts a JSON string to a SQL \`STRING\` value.

\`\`\`
STRING(json_expr)
\`\`\`

### Description

Converts a JSON string to a SQL \`STRING\` value.

Arguments:

- \`json_expr\`: JSON. For example:


### Return type

\`STRING\`


### Examples



\`\`\`
SELECT STRING(JSON '"purple"') AS color;

/*--------*
 | color |
 +--------+
 | purple |
 *--------*/
\`\`\`



\`\`\`
SELECT STRING(JSON_QUERY(JSON '{"name": "sky", "color": "blue"}', "$.color")) AS color;

/*-------*
 | color |
 +-------+
 | blue |
 *-------*/
\`\`\`

The following examples show how invalid requests are handled:



\`\`\`
-- An error is thrown if the JSON isn't of type string.
SELECT STRING(JSON '123') AS result; -- Throws an error
SELECT STRING(JSON 'null') AS result; -- Throws an error
SELECT SAFE.STRING(JSON '123') AS result; -- Returns a SQL NULL
\`\`\`


source: https://cloud.google.com/bigquery/docs/reference/standard-sql/json_functions
`;
